import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import {
  RightsizingSettingsShell,
  WorkloadDetailsContext,
} from '@cast/split-me/features/cluster/workload-optimization';

import { WORKLOAD_VIEWS } from '../../_constants';

const RIGHTSIZING_ROUTE_SUFFIXES = [
  WORKLOAD_VIEWS.VERTICAL_AUTOSCALING,
  WORKLOAD_VIEWS.HORIZONTAL_AUTOSCALING,
];

/**
 * Mounts the shared rightsizing form once for both Vertical and Horizontal
 * autoscaling routes so dirty state is preserved across tab switches.
 */
export const InventoryWorkloadRightsizingLayout = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  if (!workload) {
    return null;
  }

  return (
    <RightsizingSettingsShell
      workload={workload}
      enableRouteLeaveGuard
      allowedRouteSuffixes={RIGHTSIZING_ROUTE_SUFFIXES}
    >
      <Outlet />
    </RightsizingSettingsShell>
  );
};
